export function isLongTrade(closedPosition) {
  const symbol = closedPosition.symbol;
  if (symbol.length > 6) {
    if (symbol.substring(6).includes('C')) {
      return (
        closedPosition.side === 'buy_to_open' || closedPosition.side === 'buy'
      );
    } else if (symbol.substring(6).includes('P')) {
      return (
        closedPosition.side === 'sell_to_open' ||
        closedPosition.side === 'sell_short'
      );
    }
  }
  return closedPosition.side === 'buy';
}

export function isShortTrade(closedPosition) {
  const symbol = closedPosition.symbol;
  if (symbol.length > 6) {
    // console.log(symbol.substring(6));
    if (symbol.substring(6).includes('P')) {
      // console.log("includes P")
      // console.log(closedPosition.side)
      return (
        closedPosition.side === 'buy_to_open' || closedPosition.side === 'buy'
      );
    } else if (symbol.substring(6).includes('C')) {
      return (
        closedPosition.side === 'sell_to_open' ||
        closedPosition.side === 'sell_short'
      );
    }
  }
  return closedPosition.side === 'sell_short';
}

export function determineNewDirection(oldDirection, incommingDirection) {
  if (oldDirection === 'BOTH') return 'BOTH';

  if (oldDirection === incommingDirection) return oldDirection;

  if (oldDirection !== incommingDirection) return 'BOTH';
}
